import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable } from 'components/basic'
import FlowView from 'components/core/FlowView'
import { notify, date } from 'helpers'
import http from 'API/http'

import { OrderLog as OrderLog23 } from 'projects/flow-gui-access/views/2.3/orders'

class OrderLog extends Component {

  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'orderevents' && endpoint.version === '2.3').length !== 0) {
      return <OrderLog23 {...this.props} />
    } else {
      return (
        <div className='content-wrapper flexbox-absolute-center'>
          <NoContentBox icon='ban' text='This view is not available for versions above 2.3' />
        </div>
      )
    }
  }
}
//eslint-disable-next-line
OrderLog = connect(state => state)(OrderLog)
export default OrderLog



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/orders/log.js